import * as React from "react"

const TechEnabled = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 306.47 92.84" {...props}>
    <title>{"home-2-tech-enabled-2"}</title>
    <path
      fill="#4ead90"
      d="M128.73 63.31H16.89l2.8-4.86h111.85l-2.81 4.86zM154.06 19.44l-111.84-.01 2.8-4.85h111.85l-2.81 4.86z"
    />
    <path
      d="M306.47 16.74a9.84 9.84 0 0 0-19.36-2.46H180.42L188.84 0H53.46l-2.8 4.85h16.9v.1h112.68l-8.43 14.29h115.3a9.84 9.84 0 0 0 19.36-2.46Zm-4.92 0a4.93 4.93 0 1 1-4.94-4.92 4.94 4.94 0 0 1 4.94 4.92ZM38.98 43.71h148.4v4.92h-50.17l-.03.05-111.85.01 2.81-4.86h10.84v-.12z"
      fill="#4ead90"
    />
    <path
      fill="#4ead90"
      d="M44.79 29.18h174.67l-9.44 14.89h20.36l8.21-12.91 4.15 2.64-6.53 10.27h24.89v4.92h-28.02l-9.71 15.26h-73.06l-4.76 8.55h28.75v4.92h-31.49l-8.42 15.12H8.95v-.28H0l2.8-4.86h111.85l-.13.22h16.98l5.69-10.2h-16.78l-.12.21H8.45l2.8-4.85v-.28h128.67l7.5-13.47h73.25l6.58-10.34h-26.17l9.45-14.9H44.79v-.03H33.77l2.81-4.86h8.21v-.02z"
    />
    <circle cx={156.76} cy={17.19} r={7.27} fill="#4ead90" />
    <circle cx={239.79} cy={31.98} r={7.27} fill="#4ead90" />
    <circle cx={191.38} cy={46.62} r={7.27} fill="#4ead90" />
    <circle cx={264.89} cy={46.62} r={7.27} fill="#4ead90" />
    <circle cx={174.61} cy={74.96} r={7.27} fill="#4ead90" />
  </svg>
)

export default TechEnabled
